/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import CustomOption from './CustomOption/index'
import React from 'react'
import TysiaListDialog from 'DesignSystem/TysiaListDialog/index'
import TysiaListDialogItems from 'DesignSystem/TysiaListDialog/TysiaListDialogItems/react'
import TysiaListDialogSearchCapture from 'DesignSystem/TysiaListDialog/TysiaListDialogSearchCapture/index'
import TysiaListDialogTitle from 'DesignSystem/TysiaListDialog/TysiaListDialogTitle/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/TreatmentPlans/Content/TreatmentPlan/Appointment/Add/Content/AppointmentType/Content/Content",
  closePopover
  
}) {
let appointmentTypesValueData = fromData.useDataValue({ viewPath,
context: 'appointment_types',
})
let selectedTypeIdValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'type_id',
})
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
  return (<React.Fragment
>
<TysiaListDialog
  viewPath={`${viewPath}/TysiaListDialog`}
 height={336}
 width="100%"
 maxWidth={400}
 data="appointment_types"
 items={appointmentTypesValueData}
 data="selected.type_id"
 selected={selectedTypeIdValueData}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-2-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pt-3-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pb-4-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaListDialogTitle
  viewPath={`${viewPath}/TysiaListDialogTitle`}
 title="Select appointment type"
/>
</div>
<TysiaListDialogSearchCapture
{...childProps}
  viewPath={`${viewPath}/TysiaListDialogSearchCapture`}
/>
<TysiaListDialogItems
{...childProps}
  viewPath={`${viewPath}/TysiaListDialogItems`}
 itemDataContextName="item"
>
{childProps => (
<CustomOption
{...childProps}
 closePopover={closePopover}
/>
)}
</TysiaListDialogItems>
</React.Fragment>
)}
</TysiaListDialog>
{children}
</React.Fragment>)
}